export default __webpack_public_path__ + "static/media/DARK.f3095025.svg";